var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Single-Neutral-Actions-Remove--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Single Neutral Actions Remove Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 17.2508c0.00076 -1.1159 0.27804 -2.2142 0.80706 -3.1967 0.52901 -0.9826 1.29327 -1.8187 2.22443 -2.4337 0.93116 -0.6149 2.00021 -0.9896 3.11156 -1.0904 1.11134 -0.1007 2.23034 0.0754 3.25695 0.5128",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.375 4.87598c0 1.09401 0.4346 2.14322 1.20818 2.91681 0.77359 0.77359 1.8228 1.20819 2.91682 1.20819s2.14323 -0.4346 2.9168 -1.20819c0.7736 -0.77359 1.2082 -1.8228 1.2082 -2.91681 0 -1.09402 -0.4346 -2.14323 -1.2082 -2.91682C9.64323 1.18557 8.59402 0.750977 7.5 0.750977c-1.09402 0 -2.14323 0.434593 -2.91682 1.208183C3.8096 2.73275 3.375 3.78196 3.375 4.87598Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 17.249c0 1.5913 0.6321 3.1174 1.7574 4.2427 1.1252 1.1252 2.6513 1.7573 4.2426 1.7573 1.5913 0 3.1174 -0.6321 4.2426 -1.7573 1.1253 -1.1253 1.7574 -2.6514 1.7574 -4.2427s-0.6321 -3.1174 -1.7574 -4.2426c-1.1252 -1.1252 -2.6513 -1.7574 -4.2426 -1.7574 -1.5913 0 -3.1174 0.6322 -4.2426 1.7574 -1.1253 1.1252 -1.7574 2.6513 -1.7574 4.2426Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m19.5 14.998 -4.5 4.5",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15 14.998 4.5 4.5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9eea1c0571b44e68db45d4f020dc80a3.svg";
export { ForwardRef as ReactComponent };